module.exports = __webpack_public_path__ + "media/src/images/proctored_icons/word-285ab566e517bbc8f91759c048f91f9a.svg";